export default "__VITE_ASSET__Dd60nROe__"